module.exports = __webpack_public_path__ + "/login_ui/img/si-4fa73a7edf0d58084e74c5e7de78ecbc.svg";